module.exports = __webpack_public_path__ + "img/f-01.3e6b2a06.jpg";